<template>
    <el-dialog v-dialogDrag class="dialog" width="920px" title=""
               :visible.sync="dialogVisible" v-loading="dialoading" :close-on-click-modal="false"
               top="10vh"
               @close="close" center>
        <div slot="title">
            <div style="dialog_title">
                编辑菜单
            </div>
        </div>

        <div class="dialog_body">

            <el-tabs style="padding: 25px" v-model="activeName">
                <el-tab-pane name="first">
                    <span slot="label"><i class="el-icon-date"></i> 菜单信息 </span>

                    <el-form :model="form" ref="formData" v-loading="loading"  label-width="120px"
                             style="">
                        <el-form-item label="上级菜单">
                            <selectTree  v-model="tree_model" :rowKeys="treekeys" :tree-data="treeData" :isMulti="false"
                                        placeholder="请选择上级菜单"></selectTree>
                         </el-form-item>
                        <el-form-item label="菜单名称" prop="menuName" required>
                            <el-input  v-model="form.menuName" placeholder="请输入菜单名称"></el-input>
                        </el-form-item>
                        <el-form-item label="菜单地址" required>
                            <el-input  v-model="form.menuUrl"></el-input>
                        </el-form-item>
                        <el-form-item label="权限标识" required>
                            <el-input  v-model="form.shiroKey"></el-input>
                        </el-form-item>
                        <el-form-item label="菜单顺序" required>
                            <el-input type="number" v-model="form.menuOrder"></el-input>
                        </el-form-item>
                        <el-form-item label="是否显示" required>
                            <el-radio-group v-model="form.menuState" style="text-align: center;width: 100%">
                                <el-radio label="1" border>显示</el-radio>
                                <el-radio label="0" border>隐藏</el-radio>
                            </el-radio-group>
                        </el-form-item>

                    </el-form>
                    <div style="text-align: center;padding: 10px 0px 20px 0px">
                        <el-button type="danger" @click="close">取 消</el-button>
                        <el-button type="primary" @click="submitForm">保 存</el-button>
                    </div>

                </el-tab-pane>
                <el-tab-pane name="second">
                    <span slot="label">
                        <i class="el-icon-mobile"></i>  按钮信息
                    </span>
                    <menuBtn :formData="formData" @saveBtn="saveBtn"></menuBtn>
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-dialog>
</template>

<script>
    import selectTree from '@/components/tools/tree/selectTree'
    import menuBtn from './menuBtn'

    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        components: {selectTree,menuBtn},
        data() {
            return {
                activeName:"first",
                tree_model: {
                    id: '',
                    name: ''
                },
                treeData: [],
                treekeys: {
                    id: 'id',
                    name: 'name',
                    parent: 'parentId',
                    children: 'children'
                },
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px'
            };
        },
        mounted() {
            this.getMenuFolder();
            if(this.formData.parentId === "0"){
                this.formData.parentName = "菜单树"
            }
            this.tree_model = {
                id: this.formData.parentId,
                name: this.formData.parentName
            }
        },
        methods: {
            async getMenuFolder() {
                this.dialoading = true;
                let param = {
                    url:"/menu/selZTree",
                    param:{
                        CanMutiSel: false,
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    const retData = data.data.jsonStr;
                    if(retData){
                        this.treeData = [{
                            id:"0",
                            name:"菜单树",
                            children:retData,
                        }]
                    }
                }
                this.dialoading = false;
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            saveBtn(data){
                this.activeName = "first";
                this.form.btnData = data;
            },
            submitForm() {
                this.form.parentId = this.tree_model.id;
                if(this.form.menuName==null){
                    this.$message({message: '请输入菜单名称', type: 'error'});
                    return false;
                }

                if(this.form.menuOrder==null){
                    this.$message({message: '请输入显示顺序', type: 'error'});
                    return false;
                }
                this.$emit('submitForm', this.form)

            }
        }
    }
</script>

